export const toastTypes = {
  info: 'TOAST_INFO',
  warn: 'TOAST_WARN',
  alert: 'TOAST_ALERT'
}

export const toastActions = {
  cardCreated: 'Card Created'
}

export const toastPayload = {
  action: null,
  title: null,
  body: null,
  user: null
}

export default {
  create: () => ({
    payload: toastPayload,
    options: {
      type: toastTypes.info
    }
  }),
  toast: (payload, store) => store.dispatch('toasts/create', payload)
}
